/* eslint-disable @typescript-eslint/naming-convention */
export enum KEYS {
	UP_ARROW = 'ArrowUp',
	DOWN_ARROW = 'ArrowDown',
	LEFT_ARROW = 'ArrowLeft',
	RIGHT_ARROW = 'ArrowRight',
	PAGE_UP = 'PageUp',
	PAGE_DOWN = 'PageDown',
	ENTER = 'Enter',
	SPACE = ' ',
	SPACEBAR = 'Space',
	ESCAPE = 'Escape',
	TAB = 'Tab',
	HOME = 'Home',
	END = 'End',
}
